<span class="ih-icon" tabindex="0" role="button" [ngbPopover]="card" [popoverTitle]="title"
    popoverClass="ih-popover" placement="bottom-start" triggers="manual" container="body" [popperOptions]="popperOptions" [attr.aria-label]="title"
    (mouseenter)="show()" (mouseleave)="hideSoon()" (focus)="show()" (blur)="hideSoon()" (shown)="onShown()">
    <i class="bi bi-info-circle" aria-hidden="true"></i>
</span>

<ng-template #card>
    <ul class="ih-list">
        <li *ngFor="let item of items">
            <i class="bi" [ngClass]="item.icon" aria-hidden="true"></i>
            <div>
                <strong>{{ item.title }}</strong>
                <span>{{ item.text }}</span>
            </div>
        </li>
    </ul>
</ng-template>
